<template>
    <el-card shadow="never" class="aui-card--fill">
        <el-row style="background-color: #F3F4F4;">
            <el-col :xs="24" :md="6" style="line-height: 40px;font-size: 16px;color: #121212;font-weight: bold;">
				<img style="width: 16px;height: 16px;margin-right: 12px;" src="../../../assets/img/wofangxinxi-icon.png" />开票项目
			</el-col>
			<el-col :xs="24" :md="18">
				<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
					<el-button class="addBtn" v-if="$hasPermission('plat:platticketpro:save')" type="primary" @click="addOrUpdateHandle()">{{ $t('add') }}</el-button>
					<el-button class="exportBtn" v-if="$hasPermission('plat:platticketpro:export')" type="default" @click="dialogVisible = true;bodyId = '';">导入开票项目</el-button>
					<!-- <el-button class="exportBtn" v-if="$hasPermission('plat:platticketpro:export')" type="default" @click="exportHandle()">{{ $t('export') }}</el-button> -->
					<el-button class="refreshBtn" type="default" @click="getDataList()">刷新</el-button>
					<el-button class="delBtn" v-if="$hasPermission('plat:platticketpro:delete')" type="danger" @click="deleteHandle()">{{ $t('deleteBatch') }}</el-button>
				</el-form>
			</el-col>
		</el-row>
		<!-- 导入导出 -->
		<el-dialog
			title="导入开票项目"
			:visible.sync="dialogVisible"
			width="550px"
			:before-close="closeSubmit">
			<el-form>
				<el-form-item label="附    件:">
					<el-upload
					ref="upload"
					action=""
					accept=".xls,.xlsx"
					:on-change="handleChange"
					:http-request="fileUpload"
					:multiple="false"
					:file-list="importList"
					:auto-upload="false"
					>
					<el-button slot="trigger" size="small">选取文件</el-button>
					<div slot="tip" class="el-upload__tip">只能上传excel文件</div>
					</el-upload>
				</el-form-item>
			</el-form>
			<el-button @click="exportHandle()" class="exportBtn" type="text" size="small">下载模版</el-button>
			<span slot="footer" class="dialog-footer">
				<el-button @click="closeSubmit()">取 消</el-button>
				<el-button type="primary" v-no-more-click @click="confirmSubmit">确 定</el-button>
			</span>
		</el-dialog>
		<div class="mod-plat__platticketpro">
			<el-row style="padding:20px 20px 0 20px;">
				<el-col :xs="24" :md="6">
					<el-form>
						<el-form-item label="税源地">
							<el-select class="select-body" v-model="dataForm.bodyId" filterable clearable placeholder="请选择" style="width:70%;">
								<el-option
									v-for="item in bodyInfo"
									:key="item.id"
									:label="item.abbreviation"
									:value="item.id"
									class="option-body">
								</el-option>
							</el-select>
						</el-form-item>
					</el-form>
				</el-col>
				<el-col :xs="24" :md="18">
					<el-form :inline="true" :model="dataForm" @keyup.enter.native="getDataList()" style="text-align: right;">
						<el-button class="refreshBtn" type="primary" @click="getDataList()">查询</el-button>
					</el-form>
				</el-col>
			</el-row>
			<el-table v-loading="dataListLoading" :data="dataList" @selection-change="dataListSelectionChangeHandle" style="width: 100%;" height="100%">
				<el-table-column type="selection" header-align="center" align="center" width="50"></el-table-column>
				<el-table-column label="序号" type="index" width="50" align="center">
					<template slot-scope="scope">
						<span>{{(page - 1) * limit + scope.$index + 1}}</span>
					</template>
				</el-table-column>
				<el-table-column prop="ticketCode" label="服务分类编码" header-align="center" align="center"></el-table-column>
				<el-table-column prop="serverName" label="服务类型末级" header-align="center" align="center"></el-table-column>
				<el-table-column prop="serverLabel" label="税收简称" header-align="center" align="center"></el-table-column>
				<el-table-column prop="ticketProject" label="开票项目" header-align="center" align="center"></el-table-column>
				<el-table-column prop="abbreviation" label="税源地" header-align="center" align="center"></el-table-column>
				<el-table-column prop="isEnable" label="状态" header-align="center" align="center" show-overflow-tooltip>
					<template slot-scope="scope">
						{{ $getDictLabel("isEnable", scope.row.isEnable) }}
					</template>
				</el-table-column>
				<el-table-column :label="$t('handle')" fixed="right" header-align="center" align="center" width="150">
					<template slot-scope="scope">
						<el-button v-if="$hasPermission('plat:platticketpro:update')" type="text" size="small" @click="addOrUpdateHandle(scope.row.id)">{{ $t('update') }}</el-button>
						<el-button v-if="$hasPermission('plat:platticketpro:delete')" type="text" size="small" @click="deleteHandle(scope.row.id)">{{ $t('delete') }}</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination background
				:current-page="page"
				:page-sizes="[10, 20, 50, 100]"
				:page-size="limit"
				:total="total"
				layout="total, sizes, prev, pager, next, jumper"
				@size-change="pageSizeChangeHandle"
				@current-change="pageCurrentChangeHandle">
			</el-pagination>
			<!-- 弹窗, 新增 / 修改 -->
			<add-or-update v-if="addOrUpdateVisible" ref="addOrUpdate" @refreshDataList="getDataList"></add-or-update>
		</div>
    </el-card>
</template>

<script>
import mixinViewModule from '@/mixins/view-module'
import AddOrUpdate from './platticketpro-add-or-update'
export default {
	mixins: [mixinViewModule],
	data () {
		return {
			bodyInfo:[],//税源地
			bodyId:'',
			importList:[],
			dialogVisible:false,
			mixinViewModuleOptions: {
				getDataListURL: '/sys/plat/ticketPro/page',
				getDataListIsPage: true,
				deleteURL: '/sys/plat/ticketPro',
				deleteIsBatch: true,
				exportURL: '/sys/plat/ticketPro/exportTemplate'
			},
			dataForm: {
				bodyId:'',
				id: ''
			}
		}
	},
	components: {
		AddOrUpdate
	},
	created(){
		// 获取税源地列表
		this.$http.get(`/sys/plat/body/page?order=&orderField=&page=1&limit=1000&sydEdit=1`).then(({ data: res }) => {
			this.bodyInfo = res.data.list;
		})
	},
	methods: {
		// 导入
		fileUpload(file) {
			let form = new FormData();
			form.append("file", file.file);
			// form.append("bodyId", this.bodyId);
			this.$http.post("/sys/plat/ticketPro/importData", form).then(({ data: res }) => {
				console.log(res)
				if(res.code == 0){
					this.$message.success("导入成功");
					this.closeSubmit();
					this.getDataList();
				}else{
					this.$message.error(res.msg);
				}
					
				
			}).catch((err) => {});
		},
		handleChange(file, fileList) {
			this.importList = [file];
		},
		closeSubmit() {
			this.importList = [];
			this.dialogVisible = false;
		},
		confirmSubmit() {
			// if(!this.bodyId){
			// 	this.$message.error('请选择税源地')
			// }else 
			if(this.importList.length == 0){
				this.$message.error('请上传excel文件')
			}else{
				this.$refs.upload.submit();
			}
		},
		enableOrDisableHandle (id, isEnable) {
			this.$confirm('此操作将' + (isEnable === 0 ? '将禁用' : '将启用') + '此条数据, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				this.handle(id, isEnable)
			}).catch(() => {
				this.$message({
				type: 'info',
				message: '已取消操作'
				})
			})
		},
		handle (id, isEnable) {
			this.$http.get('/sys/plat/ticketPro/enableOrDisable', {
				params: {
				id: id,
				isEnable: isEnable
				}
			}).then(({ data: res }) => {
				if (res.code !== 0) {
				return this.$message.error(res.msg)
				} else {
				this.$message({
					message: this.$t('prompt.success'),
					type: 'success',
					duration: 500,
					onClose: () => {
					this.query()
					}
				})
				}
			}).catch(() => {})
		}
	}
}
</script>

<style lang="scss" scoped>
.mod-plat__platticketpro {
  display: flex;
  flex-direction: column;
  height: calc(100vh - 190px);
  
  .el-row {
    flex-shrink: 0;
  }
  
  .el-table {
    flex: 1;
    margin-top: 20px;
  }
  
  .el-pagination {
    flex-shrink: 0;
    margin-top: 20px;
    text-align: right;
  }
}
</style>
